import { render, staticRenderFns } from "./update-pwd.vue?vue&type=template&id=1281fd54&scoped=true"
import script from "./update-pwd.vue?vue&type=script&lang=js"
export * from "./update-pwd.vue?vue&type=script&lang=js"
import style0 from "./update-pwd.vue?vue&type=style&index=0&id=1281fd54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1281fd54",
  null
  
)

export default component.exports